import React from "react";
const LogicContext = /*#__PURE__*/React.createContext(undefined);
export default LogicContext;